/* The horizontal nav (sections/header-left.liquid) centers on the true
   viewport, not just .left_container's own box — but .left_container is a
   flex sibling of .right_container (the icon cluster) in .header-row, so
   its box is narrower than the viewport by the icon cluster's real width.
   assets/cncpts.css shifts the nav right by half that width to compensate
   (see the .header__inline-menu rule with translateX). This measures the
   icon cluster's actual rendered width and keeps that correction current —
   ResizeObserver-driven (load/resize/content-size changes), not
   scroll-driven, so it's a one-off layout measurement, not something
   fighting scroll-frame timing the way the old sticky-tracking JS did. */
(function () {
  var header = document.getElementById('shopify-section-header');
  if (!header) return;
  var root = document.documentElement;

  var observer = new ResizeObserver(function (entries) {
    var width = entries[0].contentRect.width;
    root.style.setProperty('--icon-cluster-width', width + 'px');
  });
  observer.observe(header);

  /* Exposes the horizontal nav's own left edge (assets/cncpts.css:
     .header--middle-left .header__inline-menu) as --nav-menu-left, so a
     mega-menu's column content (sections/header-left.liquid's
     .mega-menu__list) can align itself with the trigger words above it
     instead of the page's own flat left margin. Depends on both the icon
     cluster's width (already tracked above) and the viewport's own width
     (the nav is centered, so its left edge moves on resize even when the
     icon cluster itself doesn't change size) — re-measured on both. */
  var nav = document.querySelector('.left_container nav.header__inline-menu');
  function updateNavLeft() {
    if (!nav) return;
    root.style.setProperty('--nav-menu-left', nav.getBoundingClientRect().left + 'px');
  }
  if (nav) {
    var navObserver = new ResizeObserver(updateNavLeft);
    navObserver.observe(nav);
    window.addEventListener('resize', updateNavLeft);
    updateNavLeft();
  }
})();
